import { Link } from "react-router-dom";
import { useMatch, useResolvedPath } from "react-router";

const Tab = ({ to, children }) => {
  const resolved = useResolvedPath(to);
  const match = useMatch({ path: resolved.pathname, end: true });

  return (
    <Link to={to} className={`tab ${match ? "active" : ""}`}>
      {children}
    </Link>
  );
};

export default Tab;
